import { i18n } from 'i18n';
import {
  CreatePourTypesCommand, PourTypeDataDto,
  PourTypeDataId,
  UpdatePourTypeCommand
} from './api';
import {
  makeCreateMutation,
  makeListQuery,
  makeUpdateMutation
} from './useApi';

const POUR_TYPES_KEY = 'pour_types';
const POUR_TYPE_KEY = 'pour_type';

export const usePourTypesQuery = makeListQuery<string, PourTypeDataDto[]>(
  POUR_TYPES_KEY,
  (api, mineModelId) => () => api.pourTypes.getAllByProject(mineModelId),
);

export interface PourTypeQueryParams {
  mineModelId: string;
  stopeId: string;
}

export interface PourTypeCreateParams {
  mineModelId: string,
  command: CreatePourTypesCommand,
}

export const useCreatePourTypesMutation = makeCreateMutation<PourTypeDataId[], PourTypeCreateParams>(
  POUR_TYPES_KEY,
  (api) => (pourTypeData) => api.pourTypes.create(pourTypeData.mineModelId, pourTypeData.command),
  () => i18n._('Pour types created successfully'),
  [POUR_TYPES_KEY, POUR_TYPE_KEY],
);

export interface PourTypeUpdateParams {
  mineModelId: string,
  command: UpdatePourTypeCommand,
}

export const useUpdatePourTypesMutation = makeUpdateMutation<void, PourTypeUpdateParams>(
  POUR_TYPE_KEY,
  POUR_TYPES_KEY,
  (api) => (pourTypeData) => api.pourTypes.update(pourTypeData.mineModelId, pourTypeData.command),
  () => i18n._('Pour types updated successfully'),
  [POUR_TYPES_KEY, POUR_TYPE_KEY],
);
